import WhereaboutStatusCardComponent from './WhereaboutStatusCardComponent';
export default WhereaboutStatusCardComponent;
